import React, { useState, useEffect } from 'react';
import AuthService from '../services/authService';
import { AuthState } from '../types';

interface AppHeaderProps {
  showAuth?: boolean;
}

const AppHeader: React.FC<AppHeaderProps> = ({ showAuth = true }) => {
  const [authState, setAuthState] = useState<AuthState>(AuthService.getInstance().getAuthState());
  const [showUserMenu, setShowUserMenu] = useState(false);

  useEffect(() => {
    const authService = AuthService.getInstance();
    const unsubscribe = authService.subscribe(setAuthState);
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    try {
      await AuthService.getInstance().logout();
      setShowUserMenu(false);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const getUserInitials = (name: string) => {
    return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-left">
          <img src="/zone4.png" alt="Zone4" className="zone4-logo" />
        </div>
        
        <div className="header-title-center">
          <div className="app-branding">
            <img src="/series_points.png" alt="Series Points" className="series-logo-icon" />
            <div className="title-text">
              <h1>Series Points Manager</h1>
              <p>Professional race series points calculation and management</p>
            </div>
          </div>
        </div>

        {showAuth && authState.isAuthenticated && authState.user && (
          <div className="header-auth">
            <div className="user-menu">
              <button 
                className="user-button"
                onClick={() => setShowUserMenu(!showUserMenu)}
                aria-label="User menu"
              >
                <div className="user-avatar">
                  {getUserInitials(authState.user.name)}
                </div>
                <span className="user-name">{authState.user.name}</span>
                <span className="dropdown-arrow">▼</span>
              </button>

              {showUserMenu && (
                <div className="user-dropdown">
                  <div className="user-info">
                    <div className="user-details">
                      <span className="user-email">{authState.user.email}</span>
                      <span className="user-id">ID: {authState.user.id}</span>
                    </div>
                  </div>
                  <div className="dropdown-divider"></div>
                  <button 
                    className="logout-button"
                    onClick={handleLogout}
                  >
                    <span className="logout-icon">🚪</span>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Click outside to close menu */}
      {showUserMenu && (
        <div 
          className="dropdown-backdrop"
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </header>
  );
};

export default AppHeader; 